import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { priceGuide, phoneHref } from '../data';

export default function PriceGuide() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 items-center gap-12 px-4 md:px-6 py-20 md:py-24">
        <Reveal>
          <SectionLabel>Price Clarity</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            A Clear Idea of What to Expect
          </h2>
          <p className="mt-5 max-w-md text-[15px] md:text-base leading-relaxed text-foreground-700">
            Traditional clothing should feel straightforward. Here is a simple guide to the
            indicative price ranges available through SRM Textiles.
          </p>
          <p className="mt-4 max-w-md text-[13px] leading-relaxed text-foreground-600">
            Prices shown are indicative and may vary depending on fabric, design and availability.
            Contact SRM Textiles for current collections and pricing.
          </p>
          <a
            href={phoneHref}
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-phone-line" aria-hidden="true" />
            Get a Current Price
          </a>
        </Reveal>

        <Reveal delay={120}>
          <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {priceGuide.map((row) => (
              <div key={row.label} className="flex items-center justify-between px-6 py-5">
                <span className="text-[15px] font-medium text-foreground-800">{row.label}</span>
                <span className="font-heading text-2xl font-semibold text-primary-600">{row.price}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}